export default __webpack_public_path__ + "static/media/null_icon.1e1f8901.svg";